import { z } from "zod";

export const companyInfoSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Enter the company name")
    .max(120, "Keep this under 120 characters"),
  // VAT ID is optional (not every workspace is VAT-registered); allow empty.
  vatId: z.string().trim().max(40, "Keep this under 40 characters"),
});

export type CompanyInfoValues = z.infer<typeof companyInfoSchema>;
